export const range = (lowest: number, highest: number) => {
  return Array.from({ length: highest - lowest + 1 }, (_, i) => lowest + i);
};
